import React from "react";
const Cross = ({ height = "20", width = "20", ...props }) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        {...props}
      >
        <g clipPath="url(#clip0_1_2173)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.99998 19.1666C15.0626 19.1666 19.1666 15.0626 19.1666 9.99998C19.1666 4.93737 15.0626 0.833313 9.99998 0.833313C4.93737 0.833313 0.833313 4.93737 0.833313 9.99998C0.833313 15.0626 4.93737 19.1666 9.99998 19.1666ZM14.0162 6.93001C13.9789 7.01697 13.9248 7.09561 13.8569 7.16135L11.0103 10.0178L13.8559 12.8751C13.9814 13.0103 14.0498 13.189 14.0465 13.3737C14.0433 13.5584 13.9687 13.7346 13.8385 13.8652C13.7083 13.9959 13.5326 14.0707 13.3485 14.0739C13.1644 14.0772 12.9862 14.0086 12.8515 13.8827L10.004 11.0253L7.15464 13.8818C7.01991 14.0077 6.84172 14.0762 6.65761 14.073C6.47349 14.0697 6.29783 13.9949 6.16762 13.8643C6.03741 13.7337 5.96282 13.5575 5.95957 13.3728C5.95633 13.1881 6.02467 13.0093 6.1502 12.8742L8.99767 10.0178L6.1521 7.1604C6.08227 7.09513 6.02627 7.01642 5.98743 6.92897C5.94858 6.84152 5.9277 6.74712 5.92601 6.6514C5.92433 6.55567 5.94188 6.46059 5.97763 6.37182C6.01337 6.28305 6.06657 6.20241 6.13406 6.13471C6.20154 6.06701 6.28193 6.01365 6.37042 5.97779C6.45892 5.94193 6.5537 5.92433 6.64912 5.92601C6.74455 5.9277 6.83866 5.94866 6.92583 5.98762C7.01301 6.02659 7.09147 6.08277 7.15653 6.15281L10.004 9.00922L12.8524 6.15281C12.918 6.08475 12.9965 6.03048 13.0832 5.99315C13.1699 5.95583 13.2632 5.93621 13.3575 5.93543C13.4519 5.93466 13.5455 5.95274 13.6328 5.98863C13.7201 6.02451 13.7994 6.07749 13.8661 6.14445C13.9328 6.21142 13.9856 6.29105 14.0213 6.37868C14.0569 6.46631 14.0749 6.56019 14.074 6.65485C14.0732 6.74951 14.0535 6.84305 14.0162 6.93001Z"
            fill="#ED4C78"
          />
        </g>
        <defs>
          <clipPath id="clip0_1_2173">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export default Cross;
